import { render, staticRenderFns } from "./group-files-table.vue?vue&type=template&id=457efb36&"
import script from "./group-files-table.vue?vue&type=script&lang=js&"
export * from "./group-files-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports